import React, { Component } from 'react';

import { getCharFilename } from './Utils.js';

class GameStatsPlayerInfo extends Component {
    render() {
        let {data} = this.props;

        let charsLeft = [];
        let charsRight = [];

        if (data["game_type"] === "[fg_11_ga]") {
            let c1 = getCharFilename(data["characters"][1][0], data["characters"][1][1], "blue");
            let c2 = getCharFilename(data["characters"][0][0], data["characters"][0][1], "red");

            charsLeft.push(<img key="p1-img" src={c1} alt={data["characters"][1][0]} />);
            charsRight.push(<img key="p2-img" src={c2} alt={data["characters"][0][0]} />);
        } else if (data["game_type"] === "[fg_ts_2p_ga]") {
            let c1 = getCharFilename(data["characters"][2][0], data["characters"][2][1], "blue");
            let c2 = getCharFilename(data["characters"][3][0], data["characters"][3][1], "blue");
            let c3 = getCharFilename(data["characters"][0][0], data["characters"][0][1], "red");
            let c4 = getCharFilename(data["characters"][1][0], data["characters"][1][1], "red");

            charsLeft.push(<img key="p1-img" src={c1} alt={this.props.i} />);
            charsLeft.push(<img key="p2-img" src={c2} alt={this.props.i} />);

            charsRight.push(<img key="p3-img" src={c3} alt={this.props.i} />);
            charsRight.push(<img key="p4-img" src={c4} alt={this.props.i} />);
        }

        let totalDamageLeft = "NA";
        let totalDamageRight = "NA";
        let dpmLeft = "NA";
        let dpmRight = "NA";
        let hitsLeft = "NA";
        let hitsRight = "NA";
        let maxPercentLeft = "NA";
        let maxPercentRight = "NA";
        let longestStreakLeft = "NA";
        let longestStreakRight = "NA";

        if(data["has_percent_data"]) {
            totalDamageLeft = data["total_damage"]["right_team"]; // flipped for opponent's perspective
            totalDamageRight = data["total_damage"]["left_team"];
            dpmLeft = data["dpm"]["right_team"];
            dpmRight = data["dpm"]["left_team"];
            hitsLeft = data["hits"]["right_team"];
            hitsRight = data["hits"]["left_team"];
            maxPercentLeft = data["max_percent"]["right_team"];
            maxPercentRight = data["max_percent"]["left_team"];
            longestStreakLeft = data["longest_streak"]["right_team"];
            longestStreakRight = data["longest_streak"]["left_team"];
        }

        return (
            <div className="p-info">
              <table>
                <tbody>
                  <tr>
                    <td>
                      <span className="img-c">
                        {charsLeft}
                      </span>
                    </td>
                    <td>Stats</td>
                    <td>
                      <span className="img-c">
                        {charsRight}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>{totalDamageLeft}%</td><td>Total Damage</td><td>{totalDamageRight}%</td>
                  </tr>
                  <tr>
                    <td>{dpmLeft}%</td><td>Damage Per Minute</td><td>{dpmRight}%</td>
                  </tr>
                  <tr>
                    <td>{hitsLeft}</td><td>Times Hit</td><td>{hitsRight}</td>
                  </tr>
                  <tr>
                    <td>{maxPercentLeft}%</td><td>Max Percent</td><td>{maxPercentRight}%</td>
                  </tr>
                  <tr>
                    <td>{longestStreakLeft[0]} hits, {longestStreakLeft[1]}%</td><td>Longest Streak</td><td>{longestStreakRight[0]} hits, {longestStreakRight[1]}%</td>
                  </tr>
                </tbody>
              </table>
            </div>
        );
    }
}

export default GameStatsPlayerInfo;
